<!--  -->
<template>
  <div style="padding: 20px;">

    <!-- 搜索区域 -->
    <el-form :inline="true" :model="searchForm" class="search-box">

      <el-form-item label="模板标题/简介">
        <el-input
          v-model="searchForm.keywords"
          placeholder="请输入模板标题/简介"
          clearable
        />
      </el-form-item>

      <el-form-item label="类型">
        <el-select v-model="searchForm.msg_type" clearable placeholder="选择类型">
          <el-option label="图片" value="img" />
          <el-option label="文本" value="text" />
          <el-option label="图文" value="news" />
          <el-option label="小程序" value="miniprogrampage" />
        </el-select>
      </el-form-item>

      <el-form-item label="查看范围">
        <el-select
          v-model="searchForm.onlyMe"
          placeholder="请选择"
          style=""
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>

    </el-form>

    <!-- 表格 -->
    <el-table v-loading="loading" :data="tableData" border style="width: 100%">
      <el-table-column prop="template_name" label="标题" align="center" />
      <el-table-column prop="template_desc" label="简介" align="center" />
      <el-table-column prop="msg_type" label="类型" width="200" align="center">
        <template slot-scope="scope">
          {{ MSG_TYPE_MAP[scope.row.msg_type] || scope.row.msg_type }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at_text" label="创建时间" width="300" align="center" />
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="prwiedit(scope.row)">预览</el-button>
          <el-button type="text" @click="xuan(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination-right
      ref="paginationbox"
      :total="total"
      @size-change="fetchPageSizer"
      @current-change="fetchCurrentPager"
    />
    <!-- 预览标签组弹窗 -->
    <el-dialog
      title="预览"
      :visible.sync="priwdialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <PreviewDialog ref="timepreview" />
    </el-dialog>
  </div>

</template>

<script>
import { msgtemplatelist, msgtemplatecreate, msgtemplateupdate, msgtemplatedetail, msgtemplatedelete } from '@/api/bserw'
import PreviewDialog from '../../timedPush/components/PreviewDialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PreviewDialog, PaginationRight },
  data() {
    return {
      searchForm: {
        page: 1,
        page_size: 10,
        keywords: '',
        category: '',
        msg_type: '',
        onlyMe: 2
      },
      msgInfoVisible: false,
      status: null,
      tableData: [],
      total: 0,
      loading: false,
      priwdialogVisible: false,
      MSG_TYPE_MAP: {
        text: '文本',
        img: '图片',
        news: '图文链接',
        miniprogrampage: '小程序消息'
      },
      options: [
        {
          value: 2,
          label: '只看自己'
        },
        {
          value: 1,
          label: '看全部'
        }
      ]
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send() {
      this.getList()
    },
    async getList() {
      this.loading = true
      const data = await msgtemplatelist(this.searchForm)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    openDialog(val, status) {
      this.msgInfoVisible = true
      this.status = status
      setTimeout(() => {
        // // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.delayed_msg.send(val, true)
      }, 100)

      // eslint-disable-next-line eqeqeq
      if (status == 2) {
        msgtemplatedetail({ id: val.id }).then((res) => {
          console.log('res', res)
        })
      }
    },
    commit(val) {
      console.log(val)
      const data = { ...val }
      if (this.status === 1) {
        msgtemplatecreate(data).then(res => {
          if (res.code === 200) {
            this.$message.success('添加成功')
            this.msgInfoVisible = false
            this.getList()
          }
        })
      } else {
        msgtemplateupdate(data).then(res => {
          if (res.code === 200) {
            this.$message.success('修改成功')
            this.msgInfoVisible = false
            this.getList()
          }
        })
      }
    },
    // 搜索
    handleSearch() {
      this.searchForm.page = 1
      this.getList()
    },

    // 重置
    handleReset() {
      this.searchForm = {
        page: 1,
        page_size: 10,
        keywords: '',
        category: '',
        msg_type: '',
        onlyMe: 2
      }
      this.getList()
    },
    prwiedit(item) {
      console.log('item', item)
      this.priwdialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(item, 1)
      }, 100)
    },

    handleDelete(val) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        msgtemplatedelete({ id: val.id }).then((res) => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getList()
          }
        })
      })
    },
    fetchPageSizer(e) {
      this.searchForm.page_size = e
      this.getList()
    },
    fetchCurrentPager(e) {
      this.searchForm.page = e
      this.getList()
    },
    xuan(item) {
      this.$emit('callback', item)
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
